import React, { useMemo } from "react";

import { HouseholdAccount } from "@fartherfinance/frontend/api/Households/types";
import { FartherAccountId } from "@fartherfinance/frontend/api/Types";

import ArchiveFartherManagedAccountModal from "@src/multiCustodian/components/Advisor/ClientProfile/Components/Archive/ArchiveFartherManagedAccountModal";
import { AccountMenuActions } from "@src/multiCustodian/components/Advisor/Households/constants";
import SimpleModalWithTextInput from "@src/sharedComponents/Modal/SimpleModalWithTextInput/SimpleModalWithTextInput";

interface HouseholdAccountsModalManagerProps {
  currentView: AccountMenuActions | null;
  account: HouseholdAccount | null;
  onClose: () => void;
}

const HouseholdAccountsModalManager: React.FC<
  HouseholdAccountsModalManagerProps
> = ({ currentView, account, onClose }) => {
  const accountDisplayName = useMemo(
    () =>
      account && account.custodian && account.name && account.number
        ? `${account.custodian} - ${account.name} (${account.number})`
        : "",
    [account]
  );

  const clientDisplayName = useMemo(
    () =>
      account &&
      account.member &&
      account.member.firstName &&
      account.member.lastName
        ? `${account.member.firstName} ${account.member.lastName}`
        : "Client",
    [account]
  );

  const handleOnSave = (newName: string) => {
    if (account && account.accountId) {
      // Call the API to rename the account
      // Assuming there's a function `renameAccount` that handles the API call
      // renameAccount(account.accountId, newName);
      console.log(`Renaming account ${account.accountId} to ${newName}`);
      onClose();
    }
  };

  if (!account) {
    return null;
  }

  return (
    <>
      <ArchiveFartherManagedAccountModal
        isOpen={currentView === AccountMenuActions.Archive}
        accountId={account.accountId as FartherAccountId}
        accountDisplayName={accountDisplayName}
        clientId={account.member.clientId}
        clientDisplayName={clientDisplayName}
        onClose={onClose}
      />
      {currentView === AccountMenuActions.Rename && (
        <SimpleModalWithTextInput
          title="Rename Account"
          text={`Rename "${accountDisplayName}"`}
          confirmText="Rename"
          label="Account Name"
          placeholder="Enter new account name"
          defaultTextInputValue={account.name || ""}
          closeModal={onClose}
          onSave={handleOnSave}
        />
      )}
    </>
  );
};

export default HouseholdAccountsModalManager;
